import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IWorkflowConfig } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WorkflowConfigDataService {
  private endpoint = 'adv2/workflowconfig';

  constructor(private http: HttpClient) {}

  /**
   * GET all workflowConfigs for this client
   */
  get(): Observable<any> {
    return this.http.get<Observable<IWorkflowConfig[]>>(`${environment.kpHost}/${this.endpoint}/manager`).pipe(
      tap((wcs) =>
        wcs.forEach((wc) => {
          wc.dateCreated = new Date(wc.dateCreated * 1000);
          wc.dateModified = new Date(wc.dateModified * 1000);
        })
      )
    );
  }

  /**
   * POST the {@link workflowConfig} to server.
   */
  create(workflowConfig: IWorkflowConfig): Observable<IWorkflowConfig> {
    return this.http.post<IWorkflowConfig>(`${environment.kpHost}/${this.endpoint}`, workflowConfig);
  }

  /**
   * PUT the {@link workflowConfig} to server.
   */
  update(workflowConfig: IWorkflowConfig): Observable<IWorkflowConfig> {
    return this.http.put<IWorkflowConfig>(`${environment.kpHost}/${this.endpoint}`, workflowConfig);
  }

  /**
   * @param id config id to DELETE
   * TODO: should we have soft delete? isDeleted flag in dynamo?
   */
  delete(id: string): Observable<any> {
    return this.http.delete(`${environment.kpHost}/${this.endpoint}/${id}`);
  }

  uploadSectionFile(workflowConfigId: string, sectionId: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    const body = formData;
    return this.http.post(`${environment.kpHost}/${this.endpoint}/${workflowConfigId}/${sectionId}`, body);
  }
}
